<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Banner', to: '/banner' },
      { label: 'Add New' }
    ]" title="New Banner" />
    <div class="bg-white py-2.5 rounded-lg shadow-sm mb-4">
      <div class="flex-col justify-between py-0 mx-4 pb-4 border-b">
        <h4 class="font-bold text-xl leading-7 mb-4 block">Create New Banner</h4>
        <div class="bg-gray-50 border rounded-lg px-4 py-3 mb-8">
          <h3 class="font-semibold text-sm mb-3"><i class="fa-solid fa-circle-exclamation mr-1 relative -ml-1"></i>
            Banner Rules</h3>
          <ul class="list-disc list-inside text-sm text-gray-600 space-y-1 mb-1.5">
            <li>Platform IOS image banner must 2000 × 420 pixels or 1300 × 500 pixels</li>
            <li>Platform Android image banner must 1300 × 500 pixels</li>
            <li>Platform WEB image banner must 2100 × 304 pixels</li>
            <li>Banner Type Promotion Banner image banner must 900 × 450 pixels</li>
            <li>For Open URL Banner must input Payload and except Open URL Banner must input Campaign</li>
            <li>Notification date must lower than Valid From</li>
          </ul>
        </div>
        <div class="grid grid-cols-2 gap-14">
          <div class="...">
            <div>
              <label class="block  mt-0 mb-2 font-medium text-gray-700">Banner Name</label>
              <input id="name" type="text" v-model="form.name" placeholder="Enter Banner Name" :class="[
                'w-full rounded-md px-3 py-2.5 mb-1 text-sm focus:outline-none focus:ring-2',
                submitted && !form.name ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '
              ]" />
              <p v-if="submitted && !form.name" class="text-red-500 text-sm mt-0">Must be filled.</p>

            </div>
            <div class="grid grid-cols-1 gap-2 my-2">
              <div class="">
                <label class="block mb-0 font-medium text-gray-700">Start Date</label>
                <DatetimeCustom :timeDate="true" class="mt-0 relative -top-2 w-full mr-1.5" :label="''"
                  v-model="form.valid_from"></DatetimeCustom>

              </div>
              <div class="">
                <label class="block mb-0 font-medium text-gray-700">End Date</label>
                <DatetimeCustom :timeDate="true" class="mt-0 w-full relative -top-2 mr-1.5" :label="''"
                  v-model="form.valid_to"></DatetimeCustom>
              </div>
            </div>
            <div class="mt-0">
              <label class="block mb-2 font-medium text-gray-700">Platform</label>
              <ContentSelect v-model="form.platform" :options="platforms" :isError="platformValidate"
                :defaultText="'Select Platform'" class="bg-gray-50" />
              <p v-if="platformValidate" class="text-red-500 text-sm mt-1">Must be filled.</p>

            </div>
          </div>
          <div class="...">
            <label class="block mb-2 font-medium text-gray-700">Banner Image</label>

            <div
              class="relative w-72 h-36 border-2 border-dashed bg-gray-100 border-gray-300 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-50"
              :class="imageValidate && !form.file && 'bg-red-300 border-red-300'"
              @click="triggerFileUpload">
              <input ref="fileInput" type="file" accept="image/*" class="hidden" @change="handleFileChange" />

              <div v-if="this.imageFile" class="absolute inset-0">
                <img :src="this.imageFile" alt="Author Image" class="object-cover w-full h-full rounded-lg" />
                <button class="absolute top-1 right-1 bg-white text-red-500 rounded-full h-6 w-6 hover:bg-gray-100"
                  @click.stop="removeImage" title="Remove image">
                  ✕
                </button>
              </div>

              <div v-else class="flex justify-center flex-col text-center align-middle items-center text-gray-400">
                <svg  :class="imageValidate && !form.file && 'text-red-500'" class="w-6 h-6 text-gray-500 text-center dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v6.41A7.5 7.5 0 1 0 10.5 22H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Z"
                    clip-rule="evenodd" />
                  <path fill-rule="evenodd"
                    d="M9 16a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
                    clip-rule="evenodd" />
                </svg>
                <p :class="imageValidate && !form.file && 'text-red-500'" class="text-sm text-gray-500 m-0">Upload Image</p>
                <p :class="imageValidate && !form.file && 'text-red-500'" class="text-xs text-gray-400 m-0">Max 2MB</p>
              </div>
            </div>
            <p v-if="errorMessageFile" class="text-red-500 text-sm mt-1">{{ errorMessageFile }}</p>
            <p v-if="submitted && !form.file" class="text-red-500 text-sm mt-1">Must be filled.</p>
          </div>
        </div>
      </div>
      <div class="flex-col justify-between py-0 mx-4 pb-4">
        <h4 class="font-bold text-xl leading-7 my-4 px-0 block">Detail</h4>
        <div class="grid grid-cols-2 gap-14">
          <div class="w-full">
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block mb-2 font-medium text-gray-700">Banner Type</label>
                <ContentSelect v-model="form.bannerType" :options="bannerTypes" :defaultText="'Enter Banner Type'"
                  class="bg-gray-50" :isError="bannerTypeValidate" />
                <p v-if="submitted && !form.bannerType" class="text-red-500 text-sm mt-1">Must be filled.</p>
              </div>
              <div>
                <label class="block mb-2 font-medium text-gray-700">Display Zone</label>
                <ContentSelect v-model="form.displayZone" :options="displayZones" :defaultText="'Enter Display Zone'"
                  :isError="displayZoneValidate" class="bg-gray-50" />
                <p v-if="submitted && !form.displayZone" class="text-red-500 text-sm mt-1">Must be filled.</p>
              </div>
              <div>
                <label class="block mb-2 font-medium text-gray-700">Display Price</label>
                <ContentSelect v-model="form.displayPrice" :options="displayPrices" :defaultText="'Enter Display Price'"
                 :isError="displayPriceValidate"
                  class="bg-gray-50" />
                <p v-if="submitted && !form.displayPrice" class="text-red-500 text-sm mt-1">Must be filled.</p>
              </div>
              <div>
                <label class="block mb-2 font-medium text-gray-700">Sort Priority</label>
                <input id="sort_priority" type="number" v-model="form.sortPriority" placeholder="Enter Sort Priority"
                  :min="10" :max="5000"
                  :class="[
                    'w-full rounded-md px-3 py-2.5 mb-0 border-gray-300 text-sm focus:outline-none bg-gray-50 focus:ring-2',
                      submitted && !form.sortPriority ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500 mb-0' : 'border-gray-300 bg-gray-50 '
                    ]" />
                      <p v-if="submitted && !form.sortPriority" class="text-red-500 text-sm my-1">Must be filled.</p>
                <p class="text-gray-500 text-sm mt-1">*Please input between 10 - 50000</p>
              </div>
            </div>
            <div class="flex-col w-full">
              <label class="block mb-2 font-medium text-gray-700">Banner Terms and Condition</label>
              <t-textarea type="number" class="rounded-lg mb-4 text-gray-500"
                placeholder="Type banner terms and condition..." v-model="form.termCondition"></t-textarea>

            </div>
          </div>
          <div class="w-full">

            <div class="flex-col w-full mb-3 mr-3">
              <label class="block mb-2 font-medium text-gray-700">Campaign</label>

              <div v-if="form.bannerType == 'open url'">
                <input id="banner-Playload" v-model="form.payload" type="text" placeholder="Enter Banner Payload"
                  @change="form.campaign = ''"
                  :class="['w-full bg-gray-50 rounded-md  border-gray-300 px-4 py-2.5 mb-2 text-sm focus:outline-none focus:ring-2']"
                  required />
              </div>
              <div v-else class="mr-1">
                <multiselect placeholder="Select Campaign" open-direction="bottom" v-model="form.campaign" label="name"
                  track-by="name" :options="campaignSearchOptions" :loading="isCampaignSearch" :searchable="true"
                  :close-on-select="true" :options-limit="10" class="custom-multiselect"
                  :class="{ 'error': submitted && !form.campaign }" @search-change="campaignFind" :multiple="false"
                  required>
                  <template #singleLabel="{ option }">
                    <div class="text-sm font-medium text-gray-500 px-2">
                      {{ option.name }}
                    </div>
                  </template>
                  <template #caret>
                    <svg class="w-5 h-5 text-gray-500 absolute right-5 top-2.5" fill="none" stroke="currentColor"
                      stroke-width="2" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </template>
                </multiselect>
                <p v-if="submitted && !form.campaign" class="text-red-500 text-sm mt-1">Must be filled.</p>
              </div>


            </div>
            <div class="grid grid-cols-1 gap-2">
              <div class="">
                <label class="block mb-2 font-medium text-gray-700">Notification Title</label>
                <input id="notifation" type="text" v-model="form.notifation" placeholder="Enter Notification Title"
                  :class="[
                    'w-full rounded-md px-3 py-2.5 mb-2 border-gray-300 text-sm focus:outline-none bg-gray-50 focus:ring-2']" />
              </div>
              <div class="mb-2">
                <label class="block mb-2 font-medium text-gray-700">Notification Display Date</label>
                <DatetimeCustom :timeDate="true" class="mt-0 w-full relative -top-2 mr-1.5" :label="''"
                  v-model="form.notifDisplayDate"></DatetimeCustom>
              </div>
            </div>
            <div class="flex-col w-full mb-0">
              <label class="block mb-2 font-medium text-gray-700">Notification Content</label>
              <t-textarea type="number" class="rounded-lg mb-4 text-gray-500" placeholder="Type notification content..."
                v-model="form.notifContent"></t-textarea>

            </div>
          </div>

        </div>
        <div class="flex justify-start">
          <button
          :disabled="isSubmitting"
          class="mr-3 text-white bg-blue-700 rounded-lg px-2.5 py-2" type="click" @click="onSubmit">
             {{ isSubmitting ? 'Loading...' : 'Save' }}
          </button>
          <button
            class="bg-white border-blue-700 border-t border-b border-l border-r text-blue-700 mr-3 rounded-lg px-2.5 py-2"
            @click="reset">Reset Form</button>
          <button class="bg-white border text-gray-700 rounded-lg px-2.5 py-2"
            @click="$router.push('/banner')">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import constant from '../../store/constant';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs.vue';
import DatetimeCustom from '@/components/form/Datetime.vue'
import ContentSelect from '@/components/form/ContentTypeSelector.vue'
import moment from "moment";
import { EventBus } from '../../event-bus'

const BANNER_SHOW_TYPES = Object.entries(constant.BANNER_SHOW_TYPES).map(
  (item) => {
    return {
      text: item[0],
      value: item[1],
    };
  },
);

const BANNER_ZONE = Object.entries(constant.BANNER_ZONE).map((item) => {
  return {
    text: item[0],
    value: item[1],
  };
});

const BANNER_PRICE = Object.entries(constant.BANNER_PRICE).map((item) => {
  return {
    text: item[0],
    value: item[1],
  };
});

// BANNER_SHOW_TYPES
export default {
  name: 'addBanners',
  components: {
    HeaderBreadcrumbs,
    DatetimeCustom,
    ContentSelect,
  },
  data() {
    return {
      form: {
        name: '',
        platform: null,
        valid_from: moment().toString(),
        valid_to: moment().toString(),
        bannerType: null,
        payload: '',
        displayZone: null,
        notifation: '',
        displayPrice: null,
        notifDisplayDate: moment().toString(),
        termCondition: '',
        notifContent: '',
        file: null,
        campaign: '',
        sortPriority: '',
      },
      errorMessageFile: '',
      typeSortPriory: false,
      imageFile: null,
      submitted: false,
      isSubmitting: false,
      platformValidate: false,
      bannerTypeValidate: false,
      displayZoneValidate: false,
      displayPriceValidate:false,
      imageValidate:false,
      timezone: 'Asia/Bangkok',
      platforms: [
        { value: 1, text: 'IOS' },
        { value: 2, text: 'Android' },
        { value: 7, text: 'Web Store' },
      ],
      bannerTypes: [
        ...BANNER_SHOW_TYPES,
      ],
      displayZones: [
        ...BANNER_ZONE,
      ],
      displayPrices: [
        ...BANNER_PRICE,
      ],
      show: true,
      campaignSearchOptions: [],
      isCampaignSearch: false,
      debounce: null,
    };
  },
  computed: {
    ...mapState({
      isError: (state) => state.banners.isError,
      isLoading: (state) => state.banners.isLoading,
      errorMessage: (state) => state.banners.errorMessage,
      successMessage: (state) => state.banners.successMessage,
      item: (state) => state.banners.item,
      refresh: (state) => state.banners.refresh,
    }),
  },
  watch: {
    errorMessage: function () {
      if (!this.errorMessage) return;
      if(this.errorMessage==='Valid To must greater than Valid From'){
         EventBus.$emit('show-toast', {
        message: 'End Date tidak boleh kurang dari Start Date',
        type: 'error',
      });
      } else {
        EventBus.$emit('show-toast', {
          message: this.errorMessage,
          type: 'error',
      });
      }
    },
    'form.platform'() {
      this.platformValidate = false
    },
    'form.bannerType'() {
      this.bannerTypeValidate = false
    },
    'form.displayZone'() {
      this.displayZoneValidate = false
    },
    'form.displayPrice'() {
      this.displayPriceValidate = false
    },
    'form.file'() {
      this.imageValidate = true
      this.errorMessageFile = ''
    },
    successMessage: function () {
      if (!this.successMessage) return;
      EventBus.$emit('show-toast', {
        message: 'New banner has been added.',
        type: 'success',
      });
      this.$router.push({
        path: `/banner`,
      });
    },
  },
  methods: {
    ...mapActions('campaign', ['searchCampaign']),
    ...mapActions('banners', ['bannerPost']),

   onSubmit(event) {
    event.preventDefault();

    if (this.isSubmitting) return;
    this.submitted = true;
    this.isSubmitting = true;

    const { platform, campaign, bannerType, displayZone, displayPrice, file, name,sortPriority } = this.form;
    const isContentInvalid = [platform, campaign, bannerType, displayZone, displayPrice, file, sortPriority,name].some(value => value === null);

    if (isContentInvalid) {
        this.platformValidate = platform === null;
        this.bannerTypeValidate = bannerType === null;
        this.displayZoneValidate = displayZone === null;
        this.displayPriceValidate = displayPrice === null;  
        this.imageValidate = true;
        this.isSubmitting = false; 
         return;
    }

    const data = {
      ...this.form,
      valid_from: this.form.valid_from ? new Date(this.form.valid_from).toISOString() : null,
      valid_to: this.form.valid_to ? new Date(this.form.valid_to).toISOString() : null,
      notifDisplayDate: this.form.notifDisplayDate ? new Date(this.form.notifDisplayDate).toISOString() : null,
    };

    this.bannerPost(data)
      .finally(() => {
        this.isSubmitting = false;
      });
  },

    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        this.errorMessageFile = 'Only image files are allowed.';
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.errorMessageFile = 'Image size must be less than 2MB.';
        return;
      }

      this.errorMessageFile = '';
      this.imageFile = URL.createObjectURL(file)
      this.form.file = file
    },
    removeImage() {
      this.form.file = null;
      this.imageFile = null;
      this.$refs.fileInput.value = '';
      this.imageValidate = true
    },
    campaignFind(query) {
      if (!query) return;

      this.isCampaignSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          q: query,
          limit: 10,
        };
        this.searchCampaign(payload)
          .then((response) => {
            this.campaignSearchOptions = response.data.data.rows;
            this.isCampaignSearch = false;
          })
          .catch(() => {
            this.isCampaignSearch = false;
          });
      }, 600);
    },

    reset() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
  },
};
</script>
